import { IFlowOptions, ITokenData } from 'types';

export enum TYPES {
  GET_OPTIONS = '[OPTIONS]-GET_OPTIONS',
  GET_OPTIONS_SUCCESS = '[OPTIONS]-GET_OPTIONS_SUCCESS',
  GET_OPTIONS_FAILURE = '[OPTIONS]-GET_OPTIONS_FAILURE',

  GET_TOKEN = '[OPTIONS]-GET_STORE_TOKEN',
  STORE_TOKEN = '[OPTIONS]-STORE_TOKEN',
}

export type OptionsActions = IGetOptions | IGetOptionsSuccess | IGetOptionsFailure | IStoreToken | IGetToken;

// =====================
// Get options - triggers saga
// =====================
export interface IGetOptions {
  type: typeof TYPES.GET_OPTIONS;
  payload: null;
}

export function actionGetOptions(): IGetOptions {
  return {
    type: TYPES.GET_OPTIONS,
    payload: null,
  };
}

// =====================
// Get options - success
// =====================
export interface IGetOptionsSuccess {
  type: typeof TYPES.GET_OPTIONS_SUCCESS;
  payload: {
    options: IFlowOptions;
  }
}

export function actionGetOptionsSuccess(options: IFlowOptions): IGetOptionsSuccess {
  return {
    type: TYPES.GET_OPTIONS_SUCCESS,
    payload: {
      options,
    },
  };
}

// =====================
// Get options - failure
// =====================
export interface IGetOptionsFailure {
  type: typeof TYPES.GET_OPTIONS_FAILURE;
  payload: {
    error: string;
  };
}

export function actionGetOptionsFailure(error: string): IGetOptionsFailure {
  return {
    type: TYPES.GET_OPTIONS_FAILURE,
    payload: {
      error,
    },
  };
}

// =====================
// IStoreToken
// =====================
export interface IStoreToken {
  type: typeof TYPES.STORE_TOKEN;
  payload: {
    tokenData: ITokenData;
  };
}

export function actionStoreToken(tokenData: ITokenData): IStoreToken {
  return {
    type: TYPES.STORE_TOKEN,
    payload: {
      tokenData,
    },
  };
}

export interface IGetToken {
  type: typeof TYPES.GET_TOKEN;
  payload: null;
}
